import { plainToInstance, Type } from 'class-transformer';
import { User } from '../user';
import { UserInvitation } from '../user-invitation';
import { Role } from './role.class';

export class RoleWithAssignees extends Role {
	@Type(() => UserInvitation)
	invitedUsers: UserInvitation[];

	@Type(() => User)
	users: User[];

	constructor(other?: Partial<RoleWithAssignees>) {
		super();
		Object.assign(this, plainToInstance(RoleWithAssignees, other));
	}

	get assignees() {
		return [...this.invitedUsers, ...this.users];
	}
}
